import GroupView from "@/components/GroupView";
import Origination from "@/pages/saas/Origination";
import Negociation from "@/pages/saas/Negociation";
import Asymetries from "@/pages/saas/Asymetries";
import Positionnement from "@/pages/saas/Positionnement";
import DealLinks from "@/pages/saas/DealLinks";

export default function OriginationHub() {
  return (
    <GroupView
      groupKey="origination-hub"
      groupLabel="Origination"
      overline="Module groupe · Pipeline & marché"
      tabs={[
        { slug: "pipeline", label: "Opportunités", Component: Origination },
        { slug: "negociation", label: "Négociation", Component: Negociation },
        { slug: "asymetries", label: "Asymétries", Component: Asymetries },
        { slug: "positionnement", label: "Positionnement", Component: Positionnement },
        { slug: "liens", label: "Liens de partage", Component: DealLinks },
      ]}
    />
  );
}
